class CustomerAuthDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CustomerAuthDrawer-Overlay').addEventListener('click', this.close.bind(this));
    // Belt-and-suspenders: close on any click inside the drawer that lands
    // outside the panel itself, in case the overlay div isn't the element
    // actually receiving the click (e.g. covered by other content).
    this.addEventListener('click', (evt) => {
      if (!evt.target.closest('.drawer__inner')) this.close();
    });
    this.setTriggerAccessibility();
  }

  setTriggerAccessibility() {
    document.querySelectorAll('[data-open-customer-auth]').forEach((trigger) => {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        if (this.toggleAccountPopupInstead(trigger)) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        this.open(trigger);
      });
      trigger.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          if (this.toggleAccountPopupInstead(trigger)) {
            event.preventDefault();
            return;
          }
          event.preventDefault();
          this.open(trigger);
        }
      });
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll('.header__account-menu.is-open').forEach((menu) => {
        if (!menu.contains(event.target)) menu.classList.remove('is-open');
      });
    });

    document.addEventListener('keyup', (event) => {
      if (event.code !== 'Escape') return;
      document.querySelectorAll('.header__account-menu.is-open').forEach((menu) => {
        menu.classList.remove('is-open');
      });
    });
  }

  // The main header account icon opens a small popup (not this drawer) when
  // a popup exists for it and we're at a desktop width where that popup is
  // actually shown. Everywhere else (mobile widths, the popup's own "Login"
  // item, the cart icon, etc.) still opens the drawer directly.
  toggleAccountPopupInstead(trigger) {
    if (!trigger.classList.contains('header__icon--account')) return false;

    const accountMenu = trigger.closest('.header__account-menu');
    const dropdown = accountMenu && accountMenu.querySelector('.header__account-dropdown');
    if (!dropdown) return false;

    accountMenu.classList.toggle('is-open');
    return true;
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.activeElement = triggeredBy;

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        trapFocus(this.querySelector('.drawer__inner'), this.querySelector('.drawer__close'));
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('customer-auth-drawer', CustomerAuthDrawer);
